
import Vue from 'vue'

interface IData {
  category: 'my-files' | 'cid' | 'ipns' | 'dns-link'
}

export default Vue.extend({
  data: (): IData => ({
    category: 'my-files'
  }),

  computed: {
    categories() {
      return [
        'My Files',
        'CID',
        'IPNS',
        'DNSLink'
      ]
    }
  }
})
